import { useEffect, useState } from "react";

const MISURE = [
  { px: 16, sigla: "Aa", nome: "Testo normale" },
  { px: 18, sigla: "Aa+", nome: "Testo grande" },
  { px: 21, sigla: "Aa++", nome: "Testo molto grande" },
];

export const applicaTesto = (i) => {
  document.documentElement.style.fontSize = `${MISURE[i]?.px || 16}px`;
};

/** Chi vede poco ingrandisce tutto con un tocco: la scelta resta su quel tablet. */
export const TestoGrande = () => {
  const [i, setI] = useState(() => Number(localStorage.getItem("rh_testo") || 0));

  useEffect(() => {
    applicaTesto(i);
  }, [i]);

  const m = MISURE[i];
  return (
    <button
      data-testid="testo-grande-btn"
      title={m.nome}
      onClick={() => {
        const next = (i + 1) % MISURE.length;
        setI(next);
        localStorage.setItem("rh_testo", String(next));
      }}
      className={`shrink-0 rounded-md px-2.5 py-2 font-bold leading-none hover:bg-slate-100 ${
        i === 0 ? "text-slate-500" : "bg-slate-900 text-white hover:bg-slate-800"
      }`}
    >
      {m.sigla}
    </button>
  );
};
